/* ============
 * Bootstrap
 * ============
 *
 * Bootstrap is an open source toolkit for developing with HTML,
 * CSS, and JS. Quickly prototype your ideas or build your entire
 * app with our Sass variables and mixins, responsive grid system,
 * extensive prebuilt components, and powerful plugins built on jQuery.
 *
 * http://getbootstrap.com/
 */

import '../../static/css/coreui.css';


// WEBPACK FOOTER //
// ./src/plugins/coreui.js